import LegalPageShell, { H2, P, UL } from "../../components/LegalPageShell";

export default function CommunityGuidelines() {
  return (
    <LegalPageShell
      eyebrow="OUR COMMUNITY · GUIDELINES"
      title="Community Guidelines"
      lastUpdated="February 2026"
      testId="community-page"
    >
      <P>
        Wanted is a space for real people looking for real connection. These guidelines are how we keep
        that promise. By using Wanted, you agree to follow them. They sit alongside our{" "}
        <a href="/terms" className="text-gold hover:text-gold-soft">Terms of Service</a>.
      </P>

      <H2>1. Be Real</H2>
      <UL>
        <li>Use your real name and your own current photos.</li>
        <li>Do not impersonate anyone, real or fictional.</li>
        <li>Complete identity verification if asked.</li>
        <li>Only one personal account per person.</li>
      </UL>

      <H2>2. Be Kind</H2>
      <UL>
        <li>Speak to others the way you'd want to be spoken to.</li>
        <li>Harassment, bullying, threats, intimidation, and hate speech have no place on Wanted.</li>
        <li>Honor a "no." If someone declines or stops responding, give them space.</li>
        <li>Respect every member regardless of race, ethnicity, national origin, religion, gender identity, sexual orientation, age, body type, or disability.</li>
      </UL>

      <H2>3. Keep It Safe</H2>
      <UL>
        <li>No sharing of nude, sexually explicit, or graphically violent content.</li>
        <li>No content that sexualizes minors. Anyone violating this will be reported to law enforcement.</li>
        <li>No content depicting or promoting self-harm.</li>
        <li>Do not share another member's personal information, photos, or private messages without their consent.</li>
      </UL>

      <H2>4. No Solicitation</H2>
      <UL>
        <li>Wanted is not a place for sex work, escort services, or transactional arrangements.</li>
        <li>No promoting other businesses, products, or platforms.</li>
        <li>No multi-level marketing, fundraising solicitations, or "sugar" relationships in exchange for money or gifts.</li>
        <li>No scams, fraud, romance scams, or financial requests.</li>
      </UL>

      <H2>5. Stay Honest About Intent</H2>
      <P>
        Be clear about what you're looking for. Whether it's something serious, something casual, friendship,
        or simply curiosity — honesty creates the kind of conversation that becomes a real connection.
      </P>

      <H2>6. Off-Platform Behavior</H2>
      <P>
        We expect the same kindness in messages, in person, and after you exchange contact details. Conduct
        outside the app — including harassment, threats, or harmful behavior toward another member — can
        also lead to removal from Wanted.
      </P>

      <H2>7. Reporting and Blocking</H2>
      <P>
        If something doesn't feel right, please report it. You can email{" "}
        <a href="mailto:hello@joinwanted.com" className="text-gold hover:text-gold-soft">
          hello@joinwanted.com
        </a>{" "}
        with the member's name, screenshots if you have them, and a short description. Reports are
        confidential. We take every report seriously.
      </P>

      <H2>8. Consequences</H2>
      <P>
        Depending on the situation, we may issue a warning, remove specific content, suspend an account,
        or permanently remove a member from Wanted. Serious or repeated violations result in immediate
        removal. We may also report violations to law enforcement where appropriate.
      </P>
      <P>
        We will not issue refunds for accounts removed for violating these guidelines or our Terms.
      </P>

      <H2>9. A Final Note</H2>
      <P>
        We're building Wanted on the belief that everyone deserves to feel wanted — and that requires
        a community willing to treat each other with care. Thank you for helping us hold that bar high.
      </P>
    </LegalPageShell>
  );
}
